/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropertiesSigniSentTotalResource } from './propertiesSigniSentTotalResource';
import { PropertiesSigniSentTotal200ResponseMeta } from './propertiesSigniSentTotal200ResponseMeta';


export interface PropertiesSigniSentTotal200Response { 
    data: PropertiesSigniSentTotalResource;
    meta: PropertiesSigniSentTotal200ResponseMeta;
}

